module.exports = __webpack_public_path__ + "img/productWX_4.e513b2b1.png";